import React from 'react';
import {connect} from "react-redux";

import {CustomNodeFactory} from '../custom-diagram/CustomNodeFactory'

import createEngine, {CanvasWidget, DiagramModel, ZoomCanvasAction} from '@projectstorm/react-diagrams';

import {showToastForBackend, showToastForFrontend} from "../../../../../actions/toastActions";
import logicDataActions from "../../../../../actions/logicDataActions";
import logicsListActions from '../../../../../actions/logicsListActions';
import axios from "axios";
import axiosConfig from "../../../../../utils/axiosConfig";
import messageCodes from "../../../../../utils/messageCodes";


import {
    setUpLogic,
    removeAndConnectTwoNodes,
    createNewNode,
    saveLogic,
    copySelected,
    pasteSelected,
    arrangeLogic,
    removeSelected,
    removeUnconnectedEdges,
    clearAll,
    nodeOptionUpdate,
    rebuildLogicGraph,
    updateDiagram
} from '../../../../../common/GraphUtils'; // Utils file for Graph Component
import copyNodesActions from "../../../../../actions/copyNodesActions";
import {showModal} from "../../../../../actions/nodeEditorPanelActions";

class Graph extends React.Component {
    constructor(props) {
        super(props);

        const engine = createEngine({
            registerDefaultZoomCanvasAction: false,
            registerDefaultDeleteItemsAction: false
        }); // Diagram Engine defined
        engine.getActionEventBus().registerAction(new ZoomCanvasAction({inverseZoom: true}))
        engine.setMaxNumberPointsPerLink(0);
        const model = new DiagramModel();
        engine.setModel(model);
        this.state = {engine}

        this.isGraphFocused = false;

        this.onDrop = this.onDrop.bind(this);
        this.onDragOver = this.onDragOver.bind(this);
        this.logicAllFunctions = this.logicAllFunctions.bind(this);
        this.handlePressedKey = this.handlePressedKey.bind(this);
        this.handleGraphFocus = this.handleGraphFocus.bind(this);
    }

    handlePressedKey(event) {
        if (this.props.modal !== true && this.isGraphFocused) {
            if (event.code === "KeyC" && event.ctrlKey) {
                copySelected(this)
            }
            if (event.code === "KeyV" && event.ctrlKey) {
                pasteSelected(this)
            }
        }
    }

    handleGraphFocus(isFocused) {
        this.isGraphFocused = isFocused;
    }

    initializeDiagram() {
        this.state.engine.getNodeFactories().registerFactory(new CustomNodeFactory());
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handlePressedKey, false);
    }

    componentDidMount() {
        this.initializeDiagram(); // Necessary packages for the logic diagram
        setUpLogic(this); // Generating logical data according to Graph Data
        this.props.logicDataActions(this.state.engine); // Used to send engine data to Redux.
        this.logicAllFunctions(); // Used to Connection and removing function for two nodes
        const repaintCanvas = this.state.engine.repaintCanvas(true);
        repaintCanvas.then(() => {
            setTimeout(() => {
                this.state.engine.zoomToFitNodes({maxZoom: 1});
            }, 0)
        });
        this.getLogicList();
        document.addEventListener("keydown", this.handlePressedKey, false);
        const widget = document.querySelector(".diagram-widget-area")
        widget.addEventListener("pointerleave", () => {
            this.handleGraphFocus(false)
        });
        widget.addEventListener("pointerenter", () => {
            this.handleGraphFocus(true)
        });
    }

    async getLogicList() {
        axios.get(this.props.properties.logicUrl, axiosConfig())
            .then(response => {
                this.setState({
                    logicsList: response.data
                }, () => {
                    this.props.logicsListActions(response.data)
                });
            })
            .catch(err => {
                if (err.response)
                    this.props.showToastForBackend(err.response.data);
                else
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
            })
    }

    onDrop(ev) {
        ev.preventDefault();
        const title = ev.dataTransfer.getData('title');
        const type = ev.dataTransfer.getData('type');
        const sectionType = ev.dataTransfer.getData('sectionType');
        const nodeData = this.props.nodeDatas;

        const point = this.state.engine.getRelativeMousePoint(ev)
        if (title.trim().length !== 0 && type.trim().length !== 0 && sectionType.trim().length !== 0) {
            createNewNode(this, nodeData, title, type, sectionType, point);
        }

    }

    onDragOver(ev) {
        ev.preventDefault();
    }

    componentDidUpdate(_prevProps) {
        const nodeData = this.props.nodeData;
        const saveLogicNumber = this.props.saveLogic;
        const testLogicNumber = this.props.testLogic;
        const copySelectedNumber = this.props.copySelected;
        const pasteSelectedNumber = this.props.pasteSelected;
        const arrangeLogicNumber = this.props.arrangeLogic;
        const removeSelectedNumber = this.props.removeSelected;
        const removeUnconnectedEdgesNumber = this.props.removeUnconnectedEdges;
        const clearAllNumber = this.props.clearAll;
        const clickedNodeInfo = this.props.clickedNodeInfo;
        const logicGraphData = this.props.logicGraphData;
        const graphData = this.props.graphData;
        const cloneLogicNumber = this.props.cloneLogic;

        if (_prevProps.nodeData.date !== nodeData.date) {
            createNewNode(this, this.props.nodeDatas, nodeData.title, nodeData.type, nodeData.sectionType);
        }
        if (_prevProps.saveLogic !== saveLogicNumber) {
            saveLogic(this, this.props.logicId, true);
        }
        if (_prevProps.cloneLogic !== cloneLogicNumber) {
            saveLogic(this, this.props.logicId, false);
        }
        if (_prevProps.testLogic !== testLogicNumber) {
            this.props.toggleLogicTestModal();
        }
        if (_prevProps.copySelected !== copySelectedNumber) {
            copySelected(this);
        }
        if (_prevProps.pasteSelected !== pasteSelectedNumber) {
            pasteSelected(this);
        }
        if (_prevProps.arrangeLogic !== arrangeLogicNumber) {
            arrangeLogic(this);
        }
        if (_prevProps.removeSelected !== removeSelectedNumber) {
            removeSelected(this);
        }
        if (_prevProps.removeUnconnectedEdges !== removeUnconnectedEdgesNumber) {
            removeUnconnectedEdges(this);
        }
        if (_prevProps.clearAll !== clearAllNumber) {
            clearAll(this);
        }
        if (_prevProps.clickedNodeInfo !== clickedNodeInfo) {
            nodeOptionUpdate(this);
        }
        if (_prevProps.logicGraphData !== logicGraphData) {
            rebuildLogicGraph(this);
        }
        if (_prevProps.graphData !== graphData) {
            updateDiagram(this);
        }
    }

    logicAllFunctions() {
        const model = this.state.engine.getModel();
        const nodeData = this.props.nodeDatas.nodes;
        model.registerListener({
            linksUpdated: e => {
                if (!e.isCreated) {
                    removeAndConnectTwoNodes(e, model, nodeData);
                    this.state.engine.repaintCanvas();
                }
                e.link.registerListener({
                    targetPortChanged: () => {
                        removeAndConnectTwoNodes(e, model, nodeData);
                        this.state.engine.repaintCanvas();
                    },
                });
            }
        });
    }

    render() {
        return (
            <div className="diagram-widget-area" onDrop={(event) => this.onDrop(event)}
                 onDragOver={(event) => this.onDragOver(event)}>
                <CanvasWidget className="diagram-container" engine={this.state.engine}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        nodeDatas: state.nodeDatas,
        modal: state.modalInfo.modal,
        properties: state.properties,
        clickedNodeInfo: state.clickedNodeInfo,
        contextProperties: state.contextProperties,
        logicGraphData: state.logicGraphData,
        copyNodes: state.copyNodes,
        contextUpdaters: state.contextUpdaters,
        attributesToRetrieve: state.attributesToRetrieve,
        settingsToRetrieve: state.settingsToRetrieve,
        contextPropertiesToRetrieve: state.contextPropertiesToRetrieve,
        logicsList: state.logicsList
    }
}

export default connect(mapStateToProps, {
    showModal,
    showToastForBackend,
    showToastForFrontend,
    logicDataActions,
    logicsListActions,
    copyNodesActions
})(Graph);
